











import Vue from 'vue'
import { Component, Prop, VModel } from 'vue-property-decorator'

import CustomEditor from '../../../logic/Editor/CustomEditor'
import { CustomNode } from '../../../logic/Nodes'
import { CtxMenuItem, getNodeActionsMenuItems } from '../logic/MenuItems'
import ContextMenuItem from './Menu/ContextMenuItem.vue'

@Component({
  components: {
    ContextMenuItem
  }
})
export default class NodesSelectedMenu extends Vue {
  @VModel() isVisible!: boolean

  @Prop() targetNodes!: Array<CustomNode> | null

  @Prop() editor!: CustomEditor

  get nodeActionsMenuItems(): Array<CtxMenuItem> {
    const closeMenu = () => this.isVisible = false

    return getNodeActionsMenuItems(
      closeMenu,
      this.editor.copyNodes.bind(this.editor),
      this.editor.removeNode.bind(this.editor),
      this.$i18n
    )
  }
}
